/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import './index.less';

// Benign browser warning emitted by ResizeObserver (triggered by arco-design and
// chart components) that CRA's dev-server error overlay otherwise surfaces as a
// fatal error. Silence it so the overlay stays usable.
const RESIZE_OBS_WARN = /ResizeObserver loop (completed|limit exceeded)/;
window.addEventListener('error', (e) => {
  if (RESIZE_OBS_WARN.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  const msg = (e.reason as { message?: string })?.message;
  if (typeof msg === 'string' && RESIZE_OBS_WARN.test(msg)) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
